export default __webpack_public_path__ + "static/media/blue-search-icon.11356342.svg";